import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'components/atoms/Typography/Typography.jsx';

/**
 * Custom Title component
 * @param {*} props
 */
export default function Title(props) {
  const { children, textColor, ...rest } = props;
  return (
    <Typography variant="h1" textColor={textColor} {...rest}>
      {children}
    </Typography>
  );
}

Title.propTypes = {
  /**
   * Represents text to display as title
   */
  children: PropTypes.node,
  /**
   * Used variants (styles) from MaterialUI are overriden in themes.js as a typography object.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3']),
  /**
   * Custom color value, overrides default possible color values from theme
   */
  textColor: PropTypes.string,
};
